import axios from 'axios'
import router from '@/router'
import { getAccessToken, setAccessToken, removeAccessToken } from '@/utils'

const basePath = process.env.VUE_APP_API
const headers = {
  'Content-Type': 'application/json',
  Accept: 'application/x.ourchoice.v1+json'
}

const instance = axios.create({
  baseURL: basePath,
  timeout: 30000,
  headers,
  validateStatus: function () {
    return true
  }
})

instance.interceptors.request.use(
  (config) => {
    const { url, headers } = config
    const token = getAccessToken()

    if (token && token.value && config.url !== '/api/token') {
      headers['Authorization'] = token.value
    }

    if (token) {
      headers['Authorization'] = `Bearer ${encodeURIComponent(token)}`
    }

    config.url = /\?/.test(url)
      ? `${url}${/(&|\?)$/.test(url) ? '' : '&'}_t=${Date.now()}`
      : `${url}?_t=${Date.now()}`

    return config
  },
  (error) => Promise.reject(error)
)

instance.interceptors.response.use(
  (response) => {
    const authorization = response.headers['authorization'] || response.headers['Authorization']
    const expiresIn = response.headers['expires_in']

    if (/\/seller\/login/.test(response.config.url)) {
      if (authorization) {
        response.data = {
          ...response.data,
          seller_token: authorization.replace('Bearer ', ''),
          seller_expires_in: expiresIn
        }
      }
      return response
    }

    if (response.status === 401) {
      removeAccessToken()
      router.push('/login')
    }

    authorization && setAccessToken(authorization.replace('Bearer ', ''), expiresIn)

    return response
  },
  (error) => Promise.reject(error)
)

export default instance
